import React from 'react';
import { useTranslation } from 'react-i18next';
import Img from 'gatsby-image/withIEPolyfill';
import { FluidObject } from 'gatsby-image';
import LocalizedLink from './LocalizedLink';

import styles from './ArticleCard.module.scss';

interface ArticleCardProps {
  href: string;
  imageFluid: FluidObject;
  date: string;
  title: string;
  body: string;
}

const ArticleCard = ({
  href,
  imageFluid,
  date,
  title,
  body,
}: ArticleCardProps): React.ReactElement => {
  const { t } = useTranslation();
  return (
    <LocalizedLink to={href}>
      <article className="side-post" data-animation="fadeInUp">
        <Img className={styles.image} fluid={imageFluid} alt="Article Image" />
        <div className="side-post-content">
          <div className="post-content-wrapper">
            <div className="post-info">
              <h6>
                <span>{t('article_card.date_preffix', 'Publicado em')}</span>
                <span className="post-time">{date}</span>
              </h6>
            </div>
            <div className="post-title">
              <h3>{title}</h3>
            </div>
            <div className="post-body">
              <p>{body}</p>
            </div>
          </div>
        </div>
      </article>
    </LocalizedLink>
  );
};

export default ArticleCard;
